import { createFileRoute } from '@tanstack/react-router'

import { DeclinePaymentJourneyScreen } from './-components/decline-payment-journey-screen.tsx'

export const Route = createFileRoute('/product/decline-payment-journey')({
  component: DeclinePaymentJourneyScreen
})
